/* eslint-disable no-undef */
import $ from 'jquery'
import { run } from './helper'

function init(id, data, options, type, filter, locale = 'pt-br') {
  const element = $(id)[0]
  google.charts.load('current', {
    packages: ['corechart', 'controls'],
    language: locale.toLowerCase()
  })
  google.charts.setOnLoadCallback(
    drawChart(element, data, options, type, filter)
  )
}

function drawChart(element, data, options, type, filter) {
  const create = run
  return () => {
    if (type === 'ColumnChart') {
      if (data.length !== 0) {
        if (data[0].rows.length < 3) {
          options.bar.groupWidth = '20'
        } else {
          options.bar.groupWidth = '61.8%'
        }
      }
    }
    const dataSet = create(data)
    const dashboard = new google.visualization.Dashboard(element)

    if (filter) {
      const chart = new google.visualization.ChartWrapper({
        chartType: type,
        containerId: 'chart_div',
        options
      })
      const range = new google.visualization.ControlWrapper(filter)
      dashboard.bind(range, chart)
      dashboard.draw(dataSet)
    } else {
      if (dataSet) {
        const chart = new google.visualization[type](element.children[0])
        chart.draw(dataSet, options)
      }
    }
    return false
  }
}

export { init }
